import {
  handleCatchErrors,
  responseDataFormat,
} from "../../../middlewares/resolveRequests";
import {
  addUser,
  deleteUser,
  deleteUserData,
  GetAllUserRoleCommunities,
  getUsersData,
  rolesData,
  setRolesData,
  updateUseCurrentUser,
  updateUserFormData,
  userRolesData,
} from "../../../services/admin/userCRUD";

export const addUserData = async (
  data,
  isAdmin,
  isSuperAdmin,
  isMember,
  isTaskAdmin,
  token
) => {
  let response;
  try {
    response = await addUser(
      data,
      isAdmin,
      isSuperAdmin,
      isMember,
      isTaskAdmin,
      token
    );
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
export const updateUser = async (
  data,
  isAdmin,
  isSuperAdmin,
  isMember,
  isTaskAdmin,
  token
) => {
  let response;
  try {
    response = await updateUseCurrentUser(
      data,
      isAdmin,
      isSuperAdmin,
      isMember,
      isTaskAdmin,
      token
    );
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getUsers = async (
  pageNumber = 1,
  pageSize = 10,
  token,
  parentId = null
) => {
  let response;
  try {
    response = await getUsersData(pageNumber, pageSize, token, parentId);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
export const deleteUsersData = async (id) => {
  let response;
  try {
    response = await deleteUser(id);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
export const roles = async (token) => {
  let response;
  try {
    response = await rolesData(token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
export const userRoles = async (id, token) => {
  let response;
  try {
    response = await userRolesData(id, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addUserRoles = async (userId, roleId, body, token) => {
  let response;
  try {
    response = await setRolesData(userId, roleId, body, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const deleteUsers = async (id, token) => {
  let response;
  try {
    response = await deleteUserData(id, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const updateUserData = async (id, token) => {
  let response;
  try {
    response = await updateUserFormData(id, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const GetUserRoleCommunities = async (UserId, RoleId, token) => {
  let response;
  try {
    response = await GetAllUserRoleCommunities(UserId, RoleId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
